module.exports = __webpack_public_path__ + "img/img_map_no_url.688869a8.png";